import PropTypes from 'prop-types';
import { Loader } from '@progress/kendo-react-indicators';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import React from 'react';

export default function LoadingCard(props) {
  return (
    <Card type="static" canCollapse={false} expanded={true}>
      <Header title={props.title} />
      <div className="d-flex justify-content-center">
        <Loader
          style={{ color: '#1e282c' }}
          size={'medium'}
          type={'converging-spinner'}
        />
      </div>
    </Card>
  );
}

LoadingCard.propTypes = {
  title: PropTypes.string,
};
